
export function ceilCent(value) {
  if (value == null || isNaN(value)) return null;
  const n = Number(value);
  if (n > 0 && n < 0.01) return 0.01;
  return Math.round(n * 100) / 100;
}

export function formatCost(value) {
  const rounded = ceilCent(value);
  if (rounded == null) return '$0.00';
  return `$${rounded.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatCostWhole(value) {
  const rounded = ceilCent(value);
  if (rounded == null) return '$0';
  return `$${Math.round(rounded).toLocaleString()}`;
}

export function formatUsdShort(v, { subThousandDecimals = 0 } = {}) {
  const n = Number(v) || 0;
  if (n >= 1e12) return `$${(n / 1e12).toFixed(2)}T`;
  if (n >= 1e9) return `$${(n / 1e9).toFixed(2)}B`;
  if (n >= 1e6) return `$${(n / 1e6).toFixed(2)}M`;
  if (n >= 1e3) return `$${(n / 1e3).toFixed(2)}K`;
  return `$${n.toFixed(subThousandDecimals)}`;
}

export function formatSharePercent(numerator, denominator) {
  const d = Number(denominator);
  if (!d) return null;
  const pct = (Number(numerator) / d) * 100;
  const formatted = pct.toFixed(1);
  if (pct > 0 && formatted === '0.0') return '0.1%';
  return `${formatted}%`;
}

export function formatTokens(v) {
  const n = Number(v) || 0;
  if (n >= 1e12) return `${(n / 1e12).toFixed(2)}T`;
  if (n >= 1e9) return `${(n / 1e9).toFixed(2)}B`;
  if (n >= 1e6) return `${(n / 1e6).toFixed(2)}M`;
  if (n >= 1e3) return `${(n / 1e3).toFixed(1)}K`;
  return n.toLocaleString();
}

export function fmtUsd(value) {
  const n = Number(value) || 0;
  const sign = n < 0 ? '-' : '';
  const v = Math.abs(n);
  if (v >= 1e6) return `${sign}$${(v / 1e6).toFixed(2)}M`;
  if (v >= 1e4) return `${sign}$${(v / 1e3).toFixed(1)}K`;
  return `${sign}$${v.toFixed(2)}`;
}

export function fmtUsdShort(value) {
  const v = Number(value) || 0;
  if (v >= 1e6) return `$${(v / 1e6).toFixed(1)}M`;
  if (v >= 1e3) return `$${(v / 1e3).toFixed(1)}K`;
  return `$${v.toFixed(0)}`;
}

export function fmtUsdAxis(value) {
  const v = Number(value) || 0;
  const abs = Math.abs(v);
  const sign = v < 0 ? '-' : '';
  const trim = (x) => x.replace(/\.0$/, '');
  if (abs >= 999500) return `${sign}$${trim((abs / 1e6).toFixed(1))}M`;
  if (abs >= 999.5) return `${sign}$${trim((abs / 1e3).toFixed(1))}K`;
  return `${sign}$${Math.round(abs)}`;
}
